import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { LgvTSHelper } from '../../core/core.module';

@Pipe({
    name: 'LgvDateOrTime'
})
export class LgvDateOrTimePipe implements PipeTransform {

    constructor(public DP: DatePipe) { }

    /*
     * Shows short for dateTimes prior to "Today".  Shows short time for today.
     */

    transform(origDate: Date) {
        
        let startOfDay = new Date();
        startOfDay.setHours(0,0,0,0);

        let convertedOrigDate = new Date(origDate);
        // console.log(`${convertedOrigDate.toString()} >= ${startOfDay.toString()} => ${convertedOrigDate >= startOfDay}`);

        if(convertedOrigDate >= startOfDay){
            return this.DP.transform(convertedOrigDate, 'shortTime');
        } else{
            return this.DP.transform(convertedOrigDate, 'shortDate');
        }
    }
}
